var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.585 4.01c.449-.326.99-.495 1.728-.583v.615a1.063 1.063 0 0 0 2.125 0v-.707q.491-.002 1.062-.002.57 0 1.063.002v.707a1.063 1.063 0 0 0 2.124 0v-.615c.738.088 1.28.257 1.728.583.3.218.565.483.784.783.4.55.563 1.24.63 2.26H2.17c.067-1.02.23-1.71.63-2.26.219-.3.483-.565.784-.783"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.133 8.114c-.008.472-.008 1-.008 1.594 0 2.656 0 3.984.676 4.915.219.301.483.566.784.784.93.676 2.259.676 4.915.676.594 0 1.122 0 1.594-.007v-.05c0-.603 0-.971.05-1.288a4.07 4.07 0 0 1 3.386-3.386c.317-.05.684-.05 1.288-.05h.05c.007-.472.007-1 .007-1.594s0-1.122-.008-1.594H2.133m4.242 1.771a.531.531 0 0 0 0 1.063h4.25a.531.531 0 1 0 0-1.063z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.415 15.407c-.55.4-1.239.563-2.259.63 0-.645.003-.914.037-1.133a3.01 3.01 0 0 1 2.503-2.502c.218-.035.488-.037 1.133-.037-.067 1.02-.23 1.708-.63 2.258-.219.301-.483.566-.784.784M6.906 1.917a.531.531 0 0 0-1.062 0v2.125a.531.531 0 0 0 1.062 0zM11.156 1.917a.531.531 0 1 0-1.062 0v2.125a.531.531 0 1 0 1.062 0z"
  })));
};
export { SvgCalendar as ReactComponent };